import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as a}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as s}from"../../icon-registry.js";const e=s("ethereum",a`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="23"
            viewBox="0 0 14 23"
            static
            fill="none"
        >
            <g opacity="0.45">
                <mask
                    id="mask0_4874_927"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="7"
                    height="16"
                >
                    <path d="M0 0.5H6.99766V15.7042H0V0.5Z" fill="black" />
                </mask>
                <g mask="url(#mask0_4874_927)">
                    <path
                        d="M0 11.7119L6.99766 15.7042V0.5L0 11.7119Z"
                        fill="#010101"
                    />
                </g>
            </g>
            <g opacity="0.8">
                <mask
                    id="mask1_4874_927"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="6"
                    y="0"
                    width="8"
                    height="16"
                >
                    <path
                        d="M6.99951 0.5H13.9972V15.7042H6.99951V0.5Z"
                        fill="black"
                    />
                </mask>
                <g mask="url(#mask1_4874_927)">
                    <path
                        d="M6.99951 0.5V15.7042L13.9944 11.7119L6.99951 0.5Z"
                        fill="#010101"
                    />
                </g>
            </g>
            <g opacity="0.45">
                <mask
                    id="mask2_4874_927"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="12"
                    width="7"
                    height="11"
                >
                    <path
                        d="M0 12.9795H6.99766V22.4994H0V12.9795Z"
                        fill="black"
                    />
                </mask>
                <g mask="url(#mask2_4874_927)">
                    <path
                        d="M0 12.9795L6.99766 22.4994V16.9718L0 12.9795Z"
                        fill="#010101"
                    />
                </g>
            </g>
            <g opacity="0.8">
                <mask
                    id="mask3_4874_927"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="7"
                    y="12"
                    width="8"
                    height="11"
                >
                    <path
                        d="M7 12.9795H14.0004V22.4994H7V12.9795Z"
                        fill="black"
                    />
                </mask>
                <g mask="url(#mask3_4874_927)">
                    <path
                        d="M7 16.9718V22.4994L14.0004 12.9795L7 16.9718Z"
                        fill="#010101"
                    />
                </g>
            </g>
        </svg>
    `),m=s("ethereum_classic",a`
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12.9805" cy="12.0361" r="12" fill="#328332" />
            <g opacity="0.45">
                <mask
                    id="mask0_8800_9119"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="12"
                    y="3"
                    width="6"
                    height="9"
                >
                    <path
                        d="M17.9795 11.5068L12.9806 11.5068L12.9806 3.03625L17.9795 3.03625L17.9795 11.5068Z"
                        fill="black"
                    />
                </mask>
                <g mask="url(#mask0_8800_9119)">
                    <path
                        d="M17.9795 11.5068L12.9806 3.03625L12.9806 7.95459L17.9795 11.5068Z"
                        fill="white"
                    />
                </g>
            </g>
            <path
                d="M12.9814 7.95454L12.9814 3.03625L7.98055 11.5068L12.9814 7.95454Z"
                fill="white"
            />
            <g opacity="0.45">
                <mask
                    id="mask1_8800_9119"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="12"
                    y="12"
                    width="6"
                    height="10"
                >
                    <path
                        d="M17.9805 12.5654L12.9824 12.5654L12.9824 21.0356L17.9805 21.0356L17.9805 12.5654Z"
                        fill="black"
                    />
                </mask>
                <g mask="url(#mask1_8800_9119)">
                    <path
                        d="M17.9805 12.5654L12.9824 21.0356L12.9824 16.1175L17.9805 12.5654Z"
                        fill="white"
                    />
                </g>
            </g>
            <path
                d="M12.9805 16.1185L12.9805 21.0366L7.98046 12.5664L12.9805 16.1185Z"
                fill="white"
            />
            <path
                d="M12.9805 15.0361L8.98047 12.0361L12.9805 13.0361V15.0361Z"
                fill="#8EBB8E"
            />
            <path
                d="M12.9805 9.03613L8.98047 12.0361L12.9805 13.0361V9.03613Z"
                fill="white"
            />
            <path
                d="M12.9805 9.03613L16.9805 12.0361L12.9805 13.0361V9.03613Z"
                fill="#8EBB8E"
            />
            <path
                d="M12.9805 13.0361V15.0361L16.9805 12.0361L12.9805 13.0361Z"
                fill="#5B9C5B"
            />
        </svg>
    `);export{e as Ethereum,m as EthereumClassic};
